import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import { withTheme } from 'styled-components';
import StandardAlert from 'components/Alert/StandardAlert';
import { DeleteIcon } from 'components/Icons';
import globalMessages from 'components/globalMessages';

const messages = defineMessages({
  header: {
    defaultMessage: 'Delete Payment Method?',
  },
  message: {
    defaultMessage: 'Are you sure you want to delete the { cardName } ending in { cardNumber }?',
  },
});

const propTypes = {
  name: PropTypes.string,
  reference: PropTypes.string,
  theme: PropTypes.object,
};

const DeletePaymentSourceAlert = props => {
  const { name, reference, theme } = props;

  return (
    <StandardAlert
      {...props}
      Icon={DeleteIcon}
      IconFill={theme.color.danger}
      messages={{ ...messages, cancel: globalMessages.cancel, confirm: globalMessages.delete }}
      mainMessage={
        <FormattedMessage {...messages.message} values={{ cardName: name, cardNumber: <b>{reference}</b> }} />
      }
    />
  );
};

DeletePaymentSourceAlert.propTypes = propTypes;

export default withTheme(DeletePaymentSourceAlert);
